import React from 'react'

/**
 * Vue i18n 객체를 React에서 사용하기 위한 Context
 * @type {React.Context<object | null>}
 */
const i18nContext = React.createContext(null)

export default i18nContext
